import { setElementInnerHTML } from '../ui_utils/DomUtils.ts';
import { UIStoreReferralController } from './UIStoreReferralController.ts';
export class UIStoreBodyController {
    // eslint-disable-next-line class-methods-use-this
    setupReferralRewardClickHandler(contentDiv, description, image, referralReward) {
        window.addEventListener('click', (event)=>{
            if (UIStoreReferralController.isDescriptionAlreadyDisplayed(description)) {
                UIStoreReferralController.displayImageInsteadOfDescription(description, image);
                return;
            }
            if (UIStoreReferralController.isClickOnTheItem(event, contentDiv)) UIStoreReferralController.displayDescriptionInsteadOfImage(description, image);
        });
    }
    async updateReferralProgram() {
        await this.referralController.updateReferralProgram();
    }
    constructor(){
        this.membershipItems = [];
        setTimeout(()=>{
            const membershipTitle = document.getElementById('store_page_membership_title');
            if (membershipTitle == undefined) return;
            setElementInnerHTML(membershipTitle, {
                key: 'strings:storePage.sections.membership.title'
            });
        }, 100);
        this.referralController = new UIStoreReferralController(this);
    }
}
